import { createAction } from '@reduxjs/toolkit';
export const CHANGE_RINGTONE = 'CHANGE_RINGTONE';
export const changeRingtoneAction = (ringtoneId) => ({
    type: 'CHANGE_RINGTONE',
    payload: ringtoneId
});